import {
  Component,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FindControlIdService } from 'webcommon/legacy-common';
import { FcItemListBaseComponent } from '../../generic/index';
import { FcItemModalService } from '../../fc-item-modal.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  FcFacilityPortalAccessListItemDto,
  FcPersonWebAccountListItemDto,
  FindControlAdditionalSearchParametersType,
  FindControlInitDto,
  FindControlSearchParameterItemDto,
  IColumnPk,
  WebAccessTypeEnum,
} from 'webcommon/shared';
import {
  FcItemModalContext,
  FcItemModalMode,
  FcModifyModal,
  FcNewRelItemModal,
  FindControlMode,
} from '../../../models/index';
import { ApFindControlModalService } from '../../ap-findcontrol-modal.service';
import { ApModalResult, ApNotificationService, ApUndoableOperationService } from 'webcommon/core-ui';
import { ApFindControlService } from '../../ap-findcontrol.service';
import { EMPTY, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'fc-facility-portal-access-list',
  templateUrl: './fc-facility-portal-access-list.component.html',
  styleUrls: ['./fc-facility-portal-access-list.component.less']
})
export class FcFacilityPortalAccessListComponent extends FcItemListBaseComponent implements OnChanges, OnInit {
  @Input() baseId: string;
  @Input() form: FormGroup;
  @Input() listItem: FcFacilityPortalAccessListItemDto[] = [];
  @Input() isSubmitted = false;
  @Input() itemContext: FcItemModalContext;
  @Input() isDataLoaded: boolean;

  public findControlInitDto: FindControlInitDto;
  public undoComponentId: number;
  public selectedIndex: number | null;
  public showRowDetails = true;
  public selectedFormGroup = new FormGroup({});
  public facilityPortalPersonFormArray = new FormArray<FormGroup>([]);

  constructor(
    public apFindControlModalService: ApFindControlModalService,
    public fcItemModalService: FcItemModalService,
    public apNotificationService: ApNotificationService,
    protected apUndoableOperationService: ApUndoableOperationService,
    private apFindControlService: ApFindControlService,
    private elementInjector: Injector,
    private snackBar: MatSnackBar,
    ) {
    super(elementInjector);
  }

  public ngOnInit() {
    this.addControlsToForm();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.form != null) {
      this.addControlsToForm();
    }
    if ((changes.itemContext != null || changes.form != null || changes.listItem != null) && this.isDataLoaded) {
      this.setForm();
    }
  }

  public addControlsToForm(): void {
    this.form.addControl('facilityPortalPersonFormArray', this.facilityPortalPersonFormArray);
  }

  public setForm(): void {
    this.listItem?.forEach((el: FcFacilityPortalAccessListItemDto) => {
      this.addFacilityPortalPersonRow(el);
    });

    if (this.listItem?.length) {
      this.choseTableItem(0);
    }
  }

  public onShowFacilityPortalPersonGrid(): void {
    const filterData = this.getExistingPersonsFromTheGrid();
    this.apFindControlModalService.openModal(
      this.elementInjector,
      FindControlIdService.ViewFindFacilityPerson,
      [],
      this.baseId,
      'Find Facility Portal Person',
      FindControlMode.SingleSelect,
      undefined,
      {
        Type: FindControlAdditionalSearchParametersType.Standard,
        AdditionalSearchParameters: filterData
      }
    ).toPromise()
    .then((selectedItemsResult: ApModalResult<IColumnPk[]>) => {
      this.selectPerson(selectedItemsResult);
    });
  }

  public onEditTableItem(event: MouseEvent, tableItem: FcFacilityPortalAccessListItemDto): void {
    event.stopPropagation();
    const context: FcModifyModal = {
      mode: FcItemModalMode.Modify,
      findControlId: FindControlIdService.ViewPersonWeb,
      findControlName: 'Person Web Account',
      findControlConfig: this.findControlInitDto,
      selectedFindItemPk: tableItem.PersonUid,
      selectedFindItemName: tableItem.FullName,
    };
    this.fcItemModalService.openModal(context).then((result: ApModalResult<FcFacilityPortalAccessListItemDto>) => {
      if (result.isSuccess) {
        const itemIndexForModify = this.facilityPortalPersonFormArray.value
        .findIndex((element: { Pk: string }) => element.Pk === tableItem.Pk);
        const formGroupForModify = this.facilityPortalPersonFormArray.at(itemIndexForModify);
        formGroupForModify.controls.UserName.setValue(result.resultValue.UserName);
        formGroupForModify.controls.PatientWebAccess.setValue(result.resultValue.PatientWebAccess);
      }
    });
  }

  public onDeleteTableItem(event: MouseEvent, index: number): void {
    event.stopPropagation();
    const deletedFormGroup = this.facilityPortalPersonFormArray.at(index);
    this.facilityPortalPersonFormArray.removeAt(index);
    if (!this.facilityPortalPersonFormArray.controls.length) {
      this.selectedIndex = null;
    } else {
      const newIndex = index - 1;
      if (newIndex < 0 && this.facilityPortalPersonFormArray.controls.length > 0) {
        this.choseTableItem(0);
      } else {
        this.choseTableItem(index - 1);
      }
    }
    this.showUndoMessage(index, deletedFormGroup as FormGroup)
      .pipe(
        this.takeUntilDestroy(),
      ).subscribe();
  }

  public choseTableItem(index: number): void {
    this.showRowDetails = false;
    this.setSelectedIndex(index);
  }

  public setSelectedIndex(index: number): void {
    this.selectedIndex = index;
    this.selectedFormGroup = this.facilityPortalPersonFormArray.at(index) as FormGroup ?? new FormGroup({});
  }

  public onUndoClicked(insertIndex: number, itemToPaste: FormGroup): void {
    this.facilityPortalPersonFormArray.insert(insertIndex, itemToPaste as FormGroup);
    this.choseTableItem(insertIndex);
  }

  private selectPerson(selectedItemsResult: ApModalResult<IColumnPk[]>): void {
    if (selectedItemsResult.isSuccess) {
      const selectedItems = selectedItemsResult.resultValue;
      const context: FcNewRelItemModal = {
        mode: FcItemModalMode.NewRelItem,
        findControlId: FindControlIdService.ViewPersonWeb,
        findControlName: 'Person Web Account',
        findControlConfig: this.findControlInitDto,
        selectedFindItemPk: selectedItems[0].Pk,
        selectedFindItemName: selectedItems[0].FullName,
        webAccessType: WebAccessTypeEnum.FacilityPortal,
      };

      this.recordPersonToGrid(selectedItems, context);
    }
  }

  private recordPersonToGrid(selectedItems: IColumnPk[], context: FcNewRelItemModal): void {
    this.apFindControlService.getItem<FcPersonWebAccountListItemDto>(FindControlIdService.ViewPersonWeb, selectedItems[0].Pk)
      .pipe(this.takeUntilDestroy())
      .subscribe((res: FcPersonWebAccountListItemDto) => {
        if (res.PersonWebExists === false) {
          this.fcItemModalService.openModal(context).then((result: ApModalResult<FcFacilityPortalAccessListItemDto>) => {
            if (result.isSuccess) {
              const { UserName, FullName, PatientWebAccess, Pk, PersonUid } = result.resultValue;
              this.addFacilityPortalPersonRow({
                FullName,
                UserName,
                PatientWebAccess,
                Pk,
                PersonUid,
              });
            }
          });
        } else if (res.PersonWebExists === true && res.FacilityPortalWebAccess === false) {
          this.showInabilityCreationAccountNotification(res.UserName as string);
        } else if (res.PersonWebExists === true && res.FacilityPortalWebAccess === true) {
          this.addFacilityPortalPersonRow({
            FullName: selectedItems[0].FullName,
            UserName: res.UserName,
            PatientWebAccess: res.PatientWebAccess,
            Pk: selectedItems[0].Pk,
            PersonUid: selectedItems[0].PersonUid,
          });
        }
      });
  }

  private addFacilityPortalPersonRow(result: FcFacilityPortalAccessListItemDto): void {
    this.facilityPortalPersonFormArray.push(
      new FormGroup({
        UserName: new FormControl<string>(result.UserName),
        FullName: new FormControl<string>(result.FullName),
        PatientWebAccess: new FormControl<boolean>(result.PatientWebAccess),
        Pk: new FormControl<string>(result.Pk),
        PersonUid: new FormControl<string>(result.PersonUid),
        RelPatientProgramPersonWebUid: new FormControl<string>(this.systemGuid.GuidEmpty)
      })
    );
    this.form.markAsDirty();
  }

  private getExistingPersonsFromTheGrid(): FindControlSearchParameterItemDto[] {
    return this.facilityPortalPersonFormArray.value.map((item) => {
      return {
        ColumnName: 'PersonUid',
        Value: item.Pk,
        Negate: true
      };
    });
  }

  private showInabilityCreationAccountNotification(userName: string): void {
    const infoTitle = 'Person Web Account';
    const infoMessage = `Not able to create Facility Portal account. ${userName} is not a Facility Portal user.`;
    this.apNotificationService.warning(infoMessage, infoTitle);
  }

  private showUndoMessage(insertIndex: number, itemToPaste: FormGroup): Observable<void> {
    if (insertIndex === -1) {
      return EMPTY;
    }

    this.snackBar.dismiss();
    const snackBarRef = this.snackBar.open('The item was Deleted', 'Undo', {
      duration: 6000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });

    return snackBarRef.onAction().pipe(
      tap(() => this.onUndoClicked(insertIndex, itemToPaste)),
    );
  }
}
